import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectSprayEvents } from 'services/sprayEvents/selectors';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import { SprayEvent, SprayEventUuid } from 'services/sprayEvents/types';

const selectSprayEvent = createDeepEqualSelector(
    [selectSprayEvents, makeSelectQueryStringValue('sprayEventUuid')],
    (
        sprayEventsState,
        sprayEventUuid: SprayEventUuid
    ): SprayEvent | undefined => {
        if (sprayEventUuid) {
            return get(sprayEventsState, sprayEventUuid);
        }

        return undefined;
    }
);

const selectSprayEventIsCompleted = createDeepEqualSelector(
    selectSprayEvent,
    (sprayEvent) => {
        if (!sprayEvent) {
            return false;
        }

        const completedAt = get(sprayEvent, ['jobs', 0, 'completedAt']);

        return Boolean(completedAt);
    }
);

const makeSelectSprayEventIsCompleted =
    (): typeof selectSprayEventIsCompleted => selectSprayEventIsCompleted;

const selectSprayEventIsSubmitted = createDeepEqualSelector(
    selectSprayEvent,
    (sprayEvent) => get(sprayEvent, ['sprayEvent', 'isSubmitted'], false)
);

const makeSelectSprayEventIsSubmitted =
    (): typeof selectSprayEventIsSubmitted => selectSprayEventIsSubmitted;

export {
    selectSprayEvent,
    makeSelectSprayEventIsCompleted,
    makeSelectSprayEventIsSubmitted
};
